(function () {
  const initHeaderDrawer = (root) => {
    const scope = root && root.querySelectorAll ? root : document;

    scope.querySelectorAll('header-drawer details#Details-menu-drawer-container').forEach((details) => {
      if (details.dataset.dmHeaderDrawerInit === 'true') return;
      details.dataset.dmHeaderDrawerInit = 'true';

      const headerDrawer = details.closest('header-drawer');
      const breakpoint = headerDrawer?.dataset.breakpoint || 'tablet';
      const summary = details.querySelector('summary');
      const closeButton = details.querySelector('.menu-drawer__close');
      const header = details.closest('.section-header') || document.querySelector('.section-header');
      const wrapper = details.closest('.header-wrapper');
      const borderOffset = wrapper && wrapper.classList.contains('header-wrapper--border-bottom') ? 1 : 0;
      let closeTimer = null;

      const setViewportVars = () => {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
        if (header) {
          document.documentElement.style.setProperty(
            '--header-bottom-position',
            `${parseInt(header.getBoundingClientRect().bottom - borderOffset, 10)}px`
          );
        }
      };

      const onResize = () => setViewportVars();

      const applyOpenState = () => {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        header?.classList.add('menu-open');
        summary?.setAttribute('aria-expanded', 'true');
        document.body.classList.add(`overflow-hidden-${breakpoint}`);
        setViewportVars();
        window.addEventListener('resize', onResize);
        requestAnimationFrame(() => details.classList.add('menu-opening'));
      };

      const applyClosedState = () => {
        details.classList.remove('menu-opening');
        header?.classList.remove('menu-open');
        summary?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove(`overflow-hidden-${breakpoint}`);
        window.removeEventListener('resize', onResize);
      };

      const startClose = () => {
        if (!details.hasAttribute('open')) return;
        applyClosedState();
        if (closeTimer) clearTimeout(closeTimer);
        closeTimer = setTimeout(() => {
          details.removeAttribute('open');
          closeTimer = null;
        }, 400);
      };

      const syncState = () => {
        if (details.hasAttribute('open')) applyOpenState();
        else applyClosedState();
      };

      details.addEventListener('toggle', syncState);
      summary?.addEventListener('click', (event) => {
        if (!details.hasAttribute('open')) return;
        event.preventDefault();
        startClose();
      });
      details.addEventListener('keyup', (event) => {
        if (event.code?.toUpperCase() !== 'ESCAPE') return;
        if (!details.hasAttribute('open')) return;
        startClose();
        summary?.focus();
      });

      closeButton?.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        startClose();
        summary?.focus();
      });

      syncState();
    });
  };

  initHeaderDrawer(document);
  document.addEventListener('shopify:section:load', (event) => initHeaderDrawer(event.target));
})();
